import { Button, Icon, pxToRem, Text } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';
import { Link } from 'react-router';

import { routes } from '~/client/config/routes';

import { SplashPage } from '../SplashPage';

export const AccessDeniedPage: FunctionComponent = () => (
  <SplashPage>
    <Text variant="h1">Access denied</Text>
    <Text variant="lead">
      You do not have permission to access this application. If you require access, please contact
      your IT administrator.
    </Text>
    <Link to={routes.home}>
      <Button>
        <Icon icon="ui/arrow-light" width={pxToRem(14)} />
        Back to home
      </Button>
    </Link>
  </SplashPage>
);
